import Vue from 'vue';
import Vapi from 'vuex-rest-api';
import moment from 'moment';
import axios from '../api/axios';

export const resetDefaultValues = s => {
  const defaultArea = s.userSettings.find(setting => setting.key === 'defaultareaid')?.value;
  if (defaultArea !== null && defaultArea !== '') {
    s.defaultAreaId = Number(defaultArea);
  } else {
    s.defaultAreaId = null;
  }
  s.selectedFilterAreaId = s.defaultAreaId;

  const defaultLine = s.userSettings.find(setting => setting.key === 'defaultlineid')?.value;
  if (defaultLine !== null && defaultLine !== '') {
    s.defaultLineId = Number(defaultLine);
  } else {
    s.defaultLineId = null;
  }
  s.selectedFilterLineId = s.defaultLineId;
};

const store = new Vapi({
  axios,
  state: {
    userSettings: {},
    settingsList: [],
    defaultAreaId: null,
    defaultLineId: null,
    selectedFilterAreaId: null,
    selectedFilterLineId: null,
  },
})
  .get({
    action: 'getSettings',
    property: 'settingsList',
    path: () => '/internal/settings',
  })
  .get({
    action: 'getUserSettings',
    path: () => 'user/me/settings',
    onSuccess: (s, { data }) => {
      s.userSettings = data;
      resetDefaultValues(s);
    },
  })
  .put({
    action: 'setUserSetting',
    path: () => 'user/me/setting',
    onSuccess(s, { data }) {
      s.userSettings = s.userSettings.filter(setting => setting.key !== data.key);
      s.userSettings.push(data);
      resetDefaultValues(s);
    },
  })
  .getStore();

store.getters = {
  settings: s => s.settingsList,
  userSetting: s => name => (s.userSettings || {})[name],
  userSettings: s => s.userSettings,
  defaultAreaId: (s, g, rs, rg) => {
    let { defaultAreaId } = s;
    if (defaultAreaId && !rg.areas.find(a => a.id === defaultAreaId)) {
      defaultAreaId = null;
    }
    return defaultAreaId;
  },
  defaultLineId: (s, g, rs, rg) => {
    let { defaultLineId } = s;
    if (defaultLineId && !rg.lines.find(a => a.id === defaultLineId)) {
      defaultLineId = null;
    }
    return defaultLineId;
  },
  selectedFilterAreaId: (s, g, rs, rg) => {
    let { selectedFilterAreaId } = s;
    if (selectedFilterAreaId && !rg.areas.find(a => a.id === selectedFilterAreaId)) {
      selectedFilterAreaId = null;
    }
    return selectedFilterAreaId;
  },
  selectedFilterLineId: (s, g, rs, rg) => {
    let { selectedFilterLineId } = s;
    if (selectedFilterLineId && !rg.lines.find(a => a.id === selectedFilterLineId)) {
      selectedFilterLineId = null;
    }
    return selectedFilterLineId;
  },
  fromPlantTimeToUtc: (_, g) => dateTime => {
    if (!dateTime) return null;
    const plantUtcOffset = moment.tz(dateTime, g.settings.plantTimeZone).utcOffset();
    return moment.utc(dateTime).subtract(plantUtcOffset, 'minutes').format('YYYY-MM-DD HH:mm:ss');
  },
  fromUtcToPlantTime: (_, g) => dateTime => {
    if (!dateTime) return null;
    const plantUtcOffset = moment.tz(dateTime, g.settings.plantTimeZone).utcOffset();
    return moment.utc(dateTime).add(plantUtcOffset, 'minutes').format('YYYY-MM-DD HH:mm:ss');
  },
};

store.mutations.setFilterAreaId = (s, v) => {
  s.selectedFilterAreaId = v;
};

store.mutations.setFilterLineId = (s, v) => {
  s.selectedFilterLineId = v;
};

store.actions.initUserConfig = (ctx, scope) =>
  ctx.dispatch('getUserSettings', {
    params: { query: { scope } },
  });

export default store;
